export const BOOKING_MAP = {
  BookingFormGroup: "ParameterGroup",
  BookingFormElement: "ParameterElement",
  AdditionalInfo: "AdditionalInfo",
  Info: "Info",
};
